export default "__VITE_ASSET__DqunzGEy__"